import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet/es/Helmet';
import { ROLES } from 'constant/userTypes';
import Box from '@material-ui/core/Box';
import MuiTable from 'material-table';
import MuiLink from '@material-ui/core/Link';
import { Query } from 'react-apollo';
import Spin from 'components/common/Spin';
import { GET_DOCUMENTS_WITH_STATUS } from 'graphql/essays/documents';
import { GET_ESSAYS_WITH_STATUS } from 'graphql/essays';
import { Link } from 'react-router-dom';

const EssayReview = ({}) => {
  const user = useSelector((s) => s.user.user);
  const status = user.type === ROLES.LC ? 'cc_review' : 'hc_review';

  const essayColumns = [
    { title: 'ID', field: 'id' },
    { title: 'Student', field: 'user.name' },
    { title: 'Statement Name', field: 'name' },
    {
      title: '',
      render: (row) => {
        return (
          <MuiLink
            component={Link}
            to={`/students/${row.user_id}/common-app/statements`}
          >
            Go to Personal Statement
          </MuiLink>
        );
      },
    },
  ];
  const documentColumns = [
    { title: 'ID', field: 'id' },
    { title: 'Student', field: 'creator.name' },
    { title: 'University', field: 'university.university_name' },
    { title: 'Document name', field: 'filename' },
    {
      title: '',
      render: (row) => {
        return (
          <MuiLink component={Link} to={`/students/${row.created_by}/essays`}>
            Go to Essays
          </MuiLink>
        );
      },
    },
    {
      title: '',
      render: (row) => {
        return (
          <MuiLink href={row.url} target="_blank">
            View Document
          </MuiLink>
        );
      },
    },
  ];

  return (
    <Box>
      <Helmet>
        <title>Essay Review</title>
      </Helmet>
      <Query
        query={GET_ESSAYS_WITH_STATUS}
        variables={{
          status,
        }}
        fetchPolicy="cache-and-network"
      >
        {({ data, loading }) => {
          if (loading) return <Spin spinning />;
          const { rows } = data;

          return (
            <Box mb={2}>
              <MuiTable
                title="Personal Statements"
                columns={essayColumns}
                data={rows}
              />
            </Box>
          );
        }}
      </Query>
      <Query
        query={GET_DOCUMENTS_WITH_STATUS}
        variables={{ status, coachId: user.id }}
        fetchPolicy="cache-and-network"
      >
        {({ data, loading }) => {
          if (loading) return <Spin spinning />;

          const { documents } = data;

          return (
            <Box>
              <MuiTable
                title="Supplemental Essays"
                columns={documentColumns}
                data={documents}
              />
            </Box>
          );
        }}
      </Query>
    </Box>
  );
};

export default EssayReview;
